import React from 'react'

//import I18n from 'i18n';

import style from "./style.module"

function renderMinimumOrder(amount) {
    if (amount > 0) {
        return <div className={style.hint}>
            {I18n.t('pages.orders.new.available_coupon.minimum_value', {amount: amount / 100.0})}
        </div>
    } else {
        return false;
    }
}

function renderNoWeekend(noWeekend) {
    if (noWeekend) {
        return <div className={style.hint}>{I18n.t('pages.orders.new.available_coupon.no_weekend')}</div>
    } else {
        return false;
    }
}

export default function AvailableCoupon({code, discount_value, lower_limit_price_cents, no_weekend, onClick}) {

    return (
        <div onClick={onClick}
             className={`${style.box} available-coupon`}>
            <div>
                {I18n.t('pages.orders.new.available_coupon.summary', {amount: discount_value / 100.0, code: ""})}
                <span className={style.code}>{code}</span>
            </div>
            <div>{renderMinimumOrder(lower_limit_price_cents)} {renderNoWeekend(no_weekend)}</div>
        </div>
    )
}
